import React, { type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-green-50 px-6">
          <div className="text-center">
            <p className="text-4xl">🌱</p>
            <h1 className="mt-4 font-display text-xl font-semibold text-gray-900">
              Something went wrong
            </h1>
            <p className="mt-2 font-body text-sm text-gray-500">
              An unexpected error occurred. Please refresh the page.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="mt-6 rounded-sm bg-green-800 px-5 py-2.5 font-body text-sm font-semibold text-white transition-colors hover:bg-green-700"
            >
              Refresh page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
